import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Chip from 'material-ui/Chip';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import { red300 } from 'material-ui/styles/colors';

import { updateCameraIdInput } from '../../../actions/SearchParameter.Actions';

class CameraIDField extends Component {
  constructor(props) {
    super(props);

    this.handleUpdateCameraIdInput = this.handleUpdateCameraIdInput.bind(this);
    this.handleDeleteAll = this.handleDeleteAll.bind(this);
    this.handleDeleteRequest = this.handleDeleteRequest.bind(this);
  }

  handleUpdateCameraIdInput({ charCode }) {
    if (charCode !== 13) {
      return;
    }
    const { cameraID: { input }, dispatch } = this.props;
    const value = this.textField.getValue();
    if (!input.includes(value)) {
      const result = [...input, value];
      dispatch(updateCameraIdInput(result));
    } else {
      console.warn('Value has already been included.');
    }
    this.textField.getInputNode().value = '';
  }

  handleDeleteAll() {
    const { dispatch } = this.props;
    dispatch(updateCameraIdInput([]));
  }

  handleDeleteRequest(key) {
    const { dispatch, cameraID: { input } } = this.props;
    const result = [...input];
    result.splice(result.indexOf(key), 1);
    dispatch(updateCameraIdInput(result));
  }

  render() {
    const {
      cameraID: { input },
      textFieldStyle,
      chipsWrapperStyle,
      chipConfig,
      chipStyle,
      buttonGroupStyle,
      flatButtonStyle
    } = this.props;

    return (
      <div className="CameraIDField">
        <TextField
          ref={(c) => { this.textField = c; }}
          onKeyPress={this.handleUpdateCameraIdInput}
          floatingLabelText="Search by Camera IDs"
          {...textFieldStyle}
        />

        <div className="chips-wrapper" style={chipsWrapperStyle}>
          {
            input.map(chip => (
              <Chip
                key={chip}
                onRequestDelete={() => this.handleDeleteRequest(chip)}
                style={chipStyle}
                {...chipConfig}
              >
                {chip}
              </Chip>
            ))
          }
        </div>

        <div className="button-group" style={buttonGroupStyle}>
          <FlatButton
            backgroundColor="#666"
            style={{ ...flatButtonStyle, color: input.length ? flatButtonStyle.color : '#aaa' }}
            hoverColor={red300}
            disabled={input.length === 0}
            onClick={this.handleDeleteAll}
          >
            Delete All
          </FlatButton>
        </div>
      </div>
    );
  }
}

CameraIDField.propTypes = {
  dispatch: PropTypes.func.isRequired,
  cameraID: PropTypes.shape({
    input: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired,
  textFieldStyle: PropTypes.object,
  chipsWrapperStyle: PropTypes.object,
  chipConfig: PropTypes.object,
  chipStyle: PropTypes.object,
  buttonGroupStyle: PropTypes.object,
  flatButtonStyle: PropTypes.object
};

CameraIDField.defaultProps = {
  textFieldStyle: {
    underlineStyle: { borderColor: '#888' },
    underlineFocusStyle: { borderColor: '#ddd' },
    floatingLabelStyle: { color: 'white' },
    inputStyle: { color: 'white' },
    fullWidth: true
  },
  chipsWrapperStyle: {
    padding: '5pt 0',
    marginBottom: '10pt',
    whiteSpace: 'normal'
  },
  chipConfig: {
    labelStyle: {
      verticalAlign: 'top',
      fontWeight: 400
    }
  },
  chipStyle: {
    display: 'inline-block',
    marginRight: '5pt',
    marginBottom: '5pt',
    fontFamily: "'Quicksand', sans-serif",
    backgroundColor: '#eee'
  },
  buttonGroupStyle: {
    textAlign: 'right',
    marginBottom: '10pt'
  },
  flatButtonStyle: {
    color: 'white',
    marginLeft: '5pt',
    fontSize: '10pt'
  }
};

function mapStateToProps({ SearchParameter: { cameraID } }) {
  return { cameraID };
}

export default connect(mapStateToProps)(CameraIDField);



// WEBPACK FOOTER //
// ./src/containers/Aside/ImageSearchGroup/CameraIDField.jsx